import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  Report,
  ReportRequest,
  TransactionStatus,
} from '../../models/report.model';
import {
  SurveyPerformanceBuyer,
  SurveyPerformanceFilters,
  SurveyPerformanceResult,
} from '../../models/survey-performance-report.model';

export const ReportActions = createActionGroup({
  source: 'Report',
  events: {
    'Load Reports': props<{ userId: number }>(),
    'Load Reports Success': props<{ reports: Report[] }>(),
    'Load Reports Failure': props<{ error: string }>(),
    'Load Statuses': emptyProps(),
    'Load Statuses Success': props<{ statuses: TransactionStatus[] }>(),
    'Load Statuses Failure': props<{ error: string }>(),
    'Request Report': props<{ request: ReportRequest }>(),
    'Request Report Success': props<{ userId: number; msg: string }>(),
    'Request Report Failure': props<{ error: string }>(),
    'Download Report': props<{ filename: string; fileType: string }>(),
    'Download Report Success': props<{ url: string }>(),
    'Download Report Failure': props<{ error: string }>(),
    'Download User Activity Report': emptyProps(),
    'Download User Activity Report Success': props<{ filename: string }>(),
    'Download User Activity Report Failure': props<{ error: string }>(),
  },
});

export const SurveyPerformanceReportActions = createActionGroup({
  source: 'Survey Performance Report',
  events: {
    'Load Buyers': emptyProps(),
    'Load Buyers Success': props<{ buyers: SurveyPerformanceBuyer[] }>(),
    'Load Buyers Failure': props<{ error: string }>(),
    'Load Results': props<{ filters: SurveyPerformanceFilters }>(),
    'Load Results Success': props<{ results: SurveyPerformanceResult[] }>(),
    'Load Results Failure': props<{ error: string }>(),
  },
});
